<template>
    <div class="faq-content">
        <form class="search  mx-auto  d-flex flex-row justify-content-center align-items-center"
              @submit="search">
            <input type="text"
                   v-model.trim="searchText" />
            <div class="remove-icon"
                 @click="removeSearchText"
                 v-if="searchText">
                <b-icon-x />
            </div>
            <button class="search-icon"
                    data-ga-element="新保險網站_給你問_我要搜尋"
                    type="submit">
                <b-icon-search />
            </button>
        </form>
        <div class="d-flex flex-column justify-content-center align-items-center"
             v-if="loading">
            <div class="lds-dual-ring"></div>
            <p class="loading">LOADING...</p>
        </div>
        <p v-if="!loading&&searchResults.length===0&&showSearchResults"
           class="d-flex justify-content-center align-items-center">
            <b-icon-exclamation-circle-fill class="mr-1" />無符合資料</p>
        <div class="faq-questions"
             v-if="!loading&&showSearchResults">
            <PCFaq :data="searchResults"
                   :customBack="customBack"
                   @callback="callback"
                   class="pc p-0" />
            <PadFaq :data="searchResults"
                    :customBack="customBack"
                    @callback="callback"
                    class="pad p-0" />
            <MobileFaq :data="searchResults"
                       :customBack="customBack"
                       @callback="callback"
                       class="mobile p-0" />
        </div>
        <div class="d-flex flex-wrap justify-content-center align-items-center"
             v-if="!showSearchResults">
            <Options v-for="(item, index) in options"
                     :key="index"
                     :index="index"
                     :img="item.img"
                     :bold="item.bold"
                     :text1="item.text1"
                     :data-ga="index!=2?`新保險網站_問題類型_${item.text2}`:'新保險網站_問題類型_困惑'"
                     :text2="item.text2" />
        </div>
        <div class="text-center mb-40 text-style"
             v-if="!showSearchResults">還有其他保險問題?
            <span class="ml-2">就找專人免費諮詢吧</span>
        </div>
        <div class="d-flex flex-row justify-content-center align-items-center mb-40"
             v-if="!showSearchResults">
            <b-button pill
                      variant="primary"
                      @click="goReserve"
                      data-ga-element="新保險網站_給你_免費諮詢"
                      class="global-button">免費諮詢</b-button>
        </div>
        <div class="notice text-center mb-3 font-weight-bold">*提醒 : 本網站提供之問題解答僅供參考，詳細內容以各保險公司規範為主
        </div>
    </div>
</template>

<script>
import { uuid } from 'uuidv4';
import { request } from '@/service';
import Options from './Options.vue';
import PCFaq from './PCFaq.vue';
import PadFaq from './PadFaq.vue';
import MobileFaq from './MobileFaq.vue';

export default {
    name: 'FaqContent',
    components: {
        Options,
        PCFaq,
        PadFaq,
        MobileFaq
    },
    data() {
        return {
            customBack: true,
            showSearchResults: false,
            loading: false,
            searchText: '',
            searchResults: [],
            options: [
                { text1: '一定要知道的...', text2: '保險名詞', img: require('@/assets/images/faq/icon1.svg'), bold: false },
                { text1: '遇到這些情況時的...', text2: '參考解法', img: require('@/assets/images/faq/icon2.svg'), bold: false },
                { text1: '10大困惑', text2: '+錯誤', img: require('@/assets/images/faq/icon3.svg'), bold: true },
            ],
        };
    },
    created() {
        this.getData();
    },
    methods: {
        callback() {
            this.searchResults = [];
            this.showSearchResults = false;
            this.searchText = '';
        },
        getData() {
            request({
                method: 'GET',
                api: '/api/getFaq',
            }).then((res) => {
                this.$store.dispatch('setFaqData', res.data.faqTree);
            }).catch(() => {
            });
        },
        removeSearchText() {
            this.searchText = '';
            this.showSearchResults = false;
            this.searchResults = [];
        },
        search(e) {
            e.preventDefault();
            if (this.searchText === '') { return; }
            this.showSearchResults = true;
            this.loading = true;
            const data = {
                faqKeyword: this.searchText
            };

            request({
                method: 'POST',
                api: '/api/searchFaq',
                data: data
            }).then((res) => {
                const result = [];
                res.data.faqTree.forEach(item => {
                    item.children.forEach(subitem => {
                        result.push(subitem);
                    });
                });
                this.searchResults = result;
                this.loading = false;
            });
        },
        goReserve() {
            const data = {
                caseId: uuid(),
                srcId: 'FBAG_FAQ',
                productId: 'FBAG_FAQ',
            };

            request({
                method: 'POST',
                api: '/reserve/api/authenticate',
                data: data
            }).then((res) => {
                this.$cookies.set('token', res.data.jwt);
                const protocol = window.location.protocol;
                const host = window.location.host;
                window.location = `${protocol}//${host}${process.env.VUE_APP_HOST}/reserve`;
            });
        },
    }
};
</script>

<style lang="scss" scoped>
.mb-40 {
    margin-bottom: 40px;
}
.notice {
    font-size: 18px;
    color: #e60000;
    @media (max-width: 768px) {
        text-align: center;
    }
}
.faq-questions {
    min-height: 24px;
}
.faq-content {
    color: #666;
    padding: 0 15px;
    @media (max-width: 793px) {
        padding-top: 0;
    }
    .text-style {
        font-size: 18px;
    }
    .search {
        margin-top: 40px;
        margin-bottom: 40px;
        border-radius: 50px;
        border: 1px solid #ccc;
        overflow: hidden;
        padding: 3px 12px;
        max-width: 450px;
        height: 40px;
        @media (max-width: 793px) {
            margin-top: 20px;
            margin-bottom: 20px;
        }
        .remove-icon,
        .search-icon {
            border: none;
            background-color: transparent;
            color: #cccccc;
            font-size: 20px;
            cursor: pointer;
        }
        .search-icon::before {
            content: '';
            display: inline-block;
            width: 1px;
            height: 23px;
            background-color: #cccccc;
            margin: 0 8px;
            vertical-align: middle;
        }
        .remove-icon {
            font-size: 22px;
        }
        input {
            flex: 1;
            border: none;
            outline: none;
            width: 100%;
            color: #777;
        }
    }
    .options {
        cursor: pointer;
        border-radius: 6px;
        margin-bottom: 40px;
        margin-left: 1rem;
        margin-right: 1rem;
        width: 350px;
        height: 151px;
        background-color: #ecf6fc;
        @media (max-width: 793px) {
            width: 450px;
            margin-left: 0;
            margin-right: 0;
            margin-bottom: 20px;
        }
        &:first-child {
            margin-left: 0;
        }
        &:last-child {
            margin-right: 0;
        }
        .options-picture {
            background-image: url('../../assets/images/faq/icon-bg.svg');
            margin-left: 20px;
            width: 95px;
            height: 78px;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
        }
        .options-content {
            .content-title {
                color: #333333;
                font-size: 28px;
                @media (max-width: 793px) {
                    font-size: 30px;
                }
                @media (max-width: 360px) {
                    font-size: 28px;
                }
            }
            .content-note {
                font-size: 18px;
            }
        }
    }
}
.global-button {
    @media (max-width: 793px) {
        width: 450px;
    }
}

.pc {
    display: none;
    @media (min-width: 768px) {
        display: block;
    }
    .square {
        width: 32%;
    }
}
.pad {
    display: none;
    @media screen and (min-width: 577px) and (max-width: 767px) {
        display: block;
    }
    .square {
        width: 49%;
    }
}
.mobile {
    display: none;
    @media (max-width: 576px) {
        display: block;
    }
    .square {
        width: 100%;
    }
}
</style>
